module.exports = __webpack_public_path__ + "img/logo_3.5ac77508.png";